import React, { useEffect, useState } from 'react'
import CustomTable from '../../widgets/table'
import moment from 'moment'
import { Col, Row } from 'reactstrap'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { FieldItem } from '../../widgets/fields'
import { CustomButton } from '../../widgets'

const EditRecordsTableView = (props) => {
    console.log(props)
    const [tableData, setTableData] = useState<any>([]);

    useEffect(() => {
        if (props.selectedRecords && props.selectedRecords.length > 0) {
            proccessSelectedRecords();
        }
    }, [])

    const proccessSelectedRecords = () => {
        // Map selected record IDs to actual record objects
        const selectedRecords = props.selectedRecords.map((recordId: string) => {
            return props.records[Number(recordId)];
        });
        console.log(selectedRecords);

        // Build combined headers from all selected records without duplicates
        let tempHeaders: any = [];

        selectedRecords.forEach((obj, index) => {
            obj.fields.forEach(subObj => {
                if (index > 0) {
                    // Check if header with this value already exists
                    const exists = tempHeaders.some(elem => elem.value === subObj.id);
                    if (!exists) {
                        tempHeaders.push({
                            label: subObj.field_name,
                            value: subObj.id,
                            data: subObj
                        });
                    }
                } else {
                    // For first record, just push all fields
                    tempHeaders.push({
                        label: subObj.field_name,
                        value: subObj.id,
                        data: subObj
                    });
                }
            });
        });

        // Push additional "Duration" header
        tempHeaders.push({
            label: "Duration",
            value: "duration",
            data: ""
        });

        // Build processed record rows for the table
        let tempRecords: any = [];

        selectedRecords.forEach(obj => {
            let tempRow: any = {};  // <-- Use object instead of array here

            // For each header, find corresponding field in this record and assign value
            tempHeaders.forEach(header => {
                if (header.value === "duration") {
                    // calculate duration below outside this loop
                    return;
                }
                // Find the field in this record that matches header.value (field id)
                const field = obj.fields.find(f => f.id === header.value);

                if (field) {
                    // Use selected value or "-" for 'NA'
                    tempRow[header.value] = (field.field_selected_value === 'NA' || field.field_selected_value == null)
                        ? '-'
                        : field.field_selected_value;
                } else {
                    // Field not found on this record, assign "-"
                    tempRow[header.value] = '-';
                }
            });

            // Save timezone in localStorage (optional, if you need it)
            localStorage.setItem("timezone", obj.time_zone);

            // Calculate duration between end_time and start_time in HH:mm:ss format
            const msDuration = moment
                .utc(moment(obj.end_time).diff(moment(obj.start_time)))
                .format("HH:mm:ss");

            const duration = moment.duration(msDuration);

            tempRow['duration'] =
                (duration.hours() === 0 ? "" : duration.hours() + " Hrs ") +
                (duration.minutes() === 0 ? "" : duration.minutes() + " Min ") +
                (duration.seconds() === 0 ? "" : duration.seconds() + " Sec");

            tempRow['alertRules'] = obj?.alert || [];

            tempRecords.push(tempRow);
        });

        console.log(tempRecords);

        setTableData(tempRecords);
    };


    const onAction = async (type, data: any = null, i: any = null) => {
        switch (type) {
            case 'edit':
                // Handle edit action
                break;
            case 'delete':
                // Handle delete action
                break;
            default:
                break;
        }
    }

    const getData = (value, rowIndex, columnId) => {
        console.log(value, rowIndex, columnId)
        console.log(tableData)
        let updatedData = [...tableData];
        updatedData = updatedData.map((row, i) =>
            i === rowIndex
                ? { ...row, [columnId]: value }
                : row
        );
        console.log(updatedData);
        setTableData(updatedData);
    }

    const saveEditedRecords = () => { 
        console.log(tableData);
        const selectedRecords = props.selectedRecords.map((recordId: string) => {
            return props.records[Number(recordId)];
        });
        console.log(selectedRecords);
    }

    return (
        <>
            <div className="edit-records-table-view-header-container">
                <Row className='page-header m-0'>
                    <Col className={window.innerWidth > 750 ? "project-title" : "project-title-mob"} md={11}>
                        <ArrowLeftOutlined style={{ color: "#fff", fontSize: "24px", margin: "0px 10px" }} onClick={() => props.onClose()} />
                        {
                            <span style={{ color: "#fff", fontSize: "24px", margin: "0px 10px" }}>Edit Records - {props?.formData?.form_name}</span>
                        }
                    </Col>
                </Row>
            </div>
            <div className='edit-records-table-view-container-body'>
                <CustomTable
                    header="Selected Records"
                    data={tableData}
                    tableProps={props.columns}
                    isEditable={true}
                    formId={props.formData.id}
                    getdata={getData}
                    onAction={(type, data = null) => onAction(type, data)}>
                </CustomTable>

                <Row className='edit-records-table-view-save-btn-container'>
                    <Col md={4} className="add-variable-btn-container">
                        <CustomButton type="primary" text="Save" onClick={() => saveEditedRecords()}></CustomButton>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default EditRecordsTableView